
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { usePicwordPetEdit } from '@/modules/picword/pet/model/edit';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.PET.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, rewardV$, fetch, actions, SelectableBooster } = usePicwordPetEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, rewardV$, model, actions, SelectableBooster };
    }
});
